import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { useState, memo } from 'react';
import { PmiButton } from 'shell/components/shared/button';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import PmiTextField from 'shell/components/shared/text-field';
import { FiltersNotificationManagementVM } from 'practice/view-models/notification-management';
import TypeRegisterList from 'practice/components/shared/filter/filter-practice/list/type-register-list';
import { DatePicker } from '@mui/lab';
import TypeCommunicationList from './type-communication-list';
import TypeTransactionList from './type-transaction-list';
import NotificationStateList from './notification-state-list';

interface FiltersNotificationManagementProps {
  filterNotificationForm: FormikProps<Partial<FiltersNotificationManagementVM>>;
}

const FilterNotificationManagementComponent = ({
  filterNotificationForm,
}: FiltersNotificationManagementProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-batch-content"
        id="panel-batch-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterNotificationForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={3}>
              <TypeRegisterList
                value={filterNotificationForm.values.typeRegister || ''}
                onChange={(event) =>
                  filterNotificationForm.setFieldValue('typeRegister', event.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Anno"
                label="Anno"
                id="year"
                name="year"
                fullWidth
                type="text"
                variant="outlined"
                value={filterNotificationForm.values.year || ''}
                onChange={filterNotificationForm.handleChange}
                error={
                  filterNotificationForm.touched.year && Boolean(filterNotificationForm.errors.year)
                }
                helperText={filterNotificationForm.errors.year}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="Da numero"
                label="Da numero"
                id="fromNumber"
                name="fromNumber"
                fullWidth
                type="text"
                variant="outlined"
                value={filterNotificationForm.values.fromNumber || ''}
                onChange={filterNotificationForm.handleChange}
                error={
                  filterNotificationForm.touched.fromNumber &&
                  Boolean(filterNotificationForm.errors.fromNumber)
                }
                helperText={filterNotificationForm.errors.fromNumber}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <PmiTextField
                aria-label="A numero"
                label="A numero"
                id="toNumber"
                name="toNumber"
                fullWidth
                type="text"
                variant="outlined"
                value={filterNotificationForm.values.toNumber || ''}
                onChange={filterNotificationForm.handleChange}
                error={
                  filterNotificationForm.touched.toNumber &&
                  Boolean(filterNotificationForm.errors.toNumber)
                }
                helperText={filterNotificationForm.errors.toNumber}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Data trasmissione da"
                aria-label="Data trasmissione da"
                value={filterNotificationForm.values?.transmissionDateFrom || null}
                onChange={(date) =>
                  filterNotificationForm.setFieldValue('transmissionDateFrom', date)
                }
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="transmissionDateFrom"
                    fullWidth
                    error={
                      filterNotificationForm.touched?.transmissionDateFrom &&
                      Boolean(filterNotificationForm.errors?.transmissionDateFrom)
                    }
                    helperText={filterNotificationForm.errors?.transmissionDateFrom}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Data trasmissione a"
                aria-label="Data trasmissione a"
                value={filterNotificationForm.values?.transmissionDateTo || null}
                onChange={(date) =>
                  filterNotificationForm.setFieldValue('transmissionDateTo', date)
                }
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="transmissionDateTo"
                    fullWidth
                    error={
                      filterNotificationForm.touched?.transmissionDateTo &&
                      Boolean(filterNotificationForm.errors?.transmissionDateTo)
                    }
                    helperText={filterNotificationForm.errors?.transmissionDateTo}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Data stato da"
                aria-label="Data stato da"
                value={filterNotificationForm.values?.stateDateFrom || null}
                onChange={(date) => filterNotificationForm.setFieldValue('stateDateFrom', date)}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="stateDateFrom"
                    fullWidth
                    error={
                      filterNotificationForm.touched?.stateDateFrom &&
                      Boolean(filterNotificationForm.errors?.stateDateFrom)
                    }
                    helperText={filterNotificationForm.errors?.stateDateFrom}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <DatePicker
                label="Data stato a"
                aria-label="Data stato a"
                value={filterNotificationForm.values?.stateDateTo || null}
                onChange={(date) => filterNotificationForm.setFieldValue('stateDateTo', date)}
                renderInput={(params) => (
                  <PmiTextField
                    {...params}
                    id="stateDateTo"
                    fullWidth
                    error={
                      filterNotificationForm.touched?.stateDateTo &&
                      Boolean(filterNotificationForm.errors?.stateDateTo)
                    }
                    helperText={filterNotificationForm.errors?.stateDateTo}
                  />
                )}
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TypeCommunicationList
                value={filterNotificationForm.values.communicationType || ''}
                onChange={(event) =>
                  filterNotificationForm.setFieldValue('communicationType', event.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <TypeTransactionList
                value={filterNotificationForm.values.transmissionType || ''}
                onChange={(event) =>
                  filterNotificationForm.setFieldValue('transmissionType', event.target.value)
                }
              />
            </Grid>
            <Grid item xs={12} md={3}>
              <NotificationStateList
                value={filterNotificationForm.values.state || ''}
                onChange={(event) =>
                  filterNotificationForm.setFieldValue('state', event.target.value)
                }
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterNotificationForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FilterNotificationManagementComponent.displayName = 'Filters Notification management';

const FilterNotificationManagement = memo(FilterNotificationManagementComponent);

export default FilterNotificationManagement;
